<mat-toolbar>
    <mat-toolbar-row>
        <div style="display: flex; align-items: center;">
            <div style="display: flex; align-items: center; margin-left: 29px;font-weight: 600;">
                <!--                <button mat-icon-button (click)="toggle()" fxShow="false" fxShow.lt-md="true">-->
                <!--                    <mat-icon style="width: 24px; height: 24px; font-size: 24px; color: #500eff"-->
                <!--                              ngStyle.lt-sm="width: 30px; height: 30px">-->
                <!--                        menu-->
                <!--                    </mat-icon>-->
                <!--                </button>-->
                <!-- <button type="button" mat-icon-button (click)="toggleSideNav()">
                    <mat-icon style="color: #495057">menu</mat-icon>
                </button> -->
                <!-- ProjectMP -->
                <img src="./assets/images/black/logo.png" style="width:186px;height: 28px;" (click)="handleToHome()">
            </div>
            <!--            <div class="nav-item" fxLayout="row" fxHide.lt-md>-->
            <!--                &lt;!&ndash;                <button *ngIf="highestRole.weight >= 1000"&ndash;&gt;-->
            <!--                &lt;!&ndash;                        [matMenuTriggerFor]="projectDropdown">{{'projects_management' | translate}}</button>&ndash;&gt;-->
            <!--                &lt;!&ndash;                <mat-menu #projectDropdown="matMenu" backdropClass="custom__project__menu">&ndash;&gt;-->
            <!--                &lt;!&ndash;                    <div fxLayout="column">&ndash;&gt;-->
            <!--                &lt;!&ndash;                        <a mat-button&ndash;&gt;-->
            <!--                &lt;!&ndash;                           routerLink="/projects"&ndash;&gt;-->
            <!--                &lt;!&ndash;                           style="color: black; text-align: left; min-width: 220px">&ndash;&gt;-->
            <!--                &lt;!&ndash;                            {{'access_new' | translate}}&ndash;&gt;-->
            <!--                &lt;!&ndash;                        </a>&ndash;&gt;-->
            <!--                &lt;!&ndash;                        <a mat-button&ndash;&gt;-->
            <!--                &lt;!&ndash;                           routerLink="/company-projects"&ndash;&gt;-->
            <!--                &lt;!&ndash;                           style="color: black; text-align: left; min-width: 220px">&ndash;&gt;-->
            <!--                &lt;!&ndash;                            {{'company_projects'| translate}}&ndash;&gt;-->
            <!--                &lt;!&ndash;                        </a>&ndash;&gt;-->
            <!--                &lt;!&ndash;                        <a mat-button&ndash;&gt;-->
            <!--                &lt;!&ndash;                           routerLink="/my-projects"&ndash;&gt;-->
            <!--                &lt;!&ndash;                           style="color: black; text-align: left; min-width: 220px">&ndash;&gt;-->
            <!--                &lt;!&ndash;                            {{'my_projects'| translate}}&ndash;&gt;-->
            <!--                &lt;!&ndash;                        </a>&ndash;&gt;-->
            <!--                &lt;!&ndash;                    </div>&ndash;&gt;-->
            <!--                &lt;!&ndash;                </mat-menu>&ndash;&gt;-->
            <!--                <ng-container *ngIf="user.roles[0].weight >= 1000">-->
            <!--                    <button routerLink="/projects"-->
            <!--                            routerLinkActive="active">-->
            <!--                        {{'access_new' | translate}}-->
            <!--                    </button>-->
            <!--                    <button routerLink="/company-projects"-->
            <!--                            routerLinkActive="active">-->
            <!--                        {{'company_projects'| translate}}-->
            <!--                    </button>-->
            <!--&lt;!&ndash;                    <button routerLink="/contact"&ndash;&gt;-->
            <!--&lt;!&ndash;                            routerLinkActive="active">&ndash;&gt;-->
            <!--&lt;!&ndash;                        {{'contact' | translate}}&ndash;&gt;-->
            <!--&lt;!&ndash;                    </button>&ndash;&gt;-->
            <!--                    <button routerLink="/staff"-->
            <!--                            routerLinkActive="active">-->
            <!--                        {{'staff' | translate}}-->
            <!--                    </button>-->
            <!--                </ng-container>-->

            <!--                <ng-container *ngIf="user.roles[0].weight < 1000">-->
            <!--                    <button routerLink="/my-boutique"-->
            <!--                            routerLinkActive="active">-->
            <!--                        {{'my_boutique' | translate}}-->
            <!--                    </button>-->
            <!--                    <button routerLink="/my-projects"-->
            <!--                            routerLinkActive="active">-->
            <!--                        {{'my_projects'| translate}}-->
            <!--                    </button>-->
            <!--                </ng-container>-->
            <!--                <button *ngIf="company && company.switchContact"-->
            <!--                        routerLink="/contact"-->
            <!--                        routerLinkActive="active">-->
            <!--                    {{'contact' | translate}}-->
            <!--                </button>-->
            <!--                <button routerLink="/message"-->
            <!--                        routerLinkActive="active">-->
            <!--                    {{'message' | translate}}-->
            <!--                </button>-->
            <!--            </div>-->
        </div>

        <!-- <div style="position: absolute;left: 289px;" class="box">
            <img src="./assets/images/black/search.png" style="width:20px;height: 20px;margin-left: 12px;">
            <input class="find" placeholder="Search for projects" (input)=handleInput($event)>
        </div> -->
        <!-- <div style="position: absolute;left: 289px;" class="box">
            <img src="./assets/images/black/search.png" style="width:20px;height: 20px;margin-left: 12px;">
            <div style="background:#2142FF;width:2px;height:20px;margin-left:18px;"></div>
            <input matInput placeholder="Search for things like: agencies, EOI’s, and why you’re an awsome person.  "
                style="margin-left: 22px;">
        </div> -->

        <div style="display: flex; align-items: center">
            <div class="mr_40 mt_10 notification" (click)="handleToNotification()">
              <mat-icon matBadge="{{unreadNotificationCount}}" matBadgeColor="warn"
              *ngIf="unreadNotificationCount > 0">
                <img src="./assets/images/black/bel.png" class="bel_image cursor_pointer">
              </mat-icon>
              <img src="./assets/images/black/bel.png" class="bel_image cursor_pointer"
              *ngIf="unreadNotificationCount === 0">
                <!-- <span matBadge="4" matBadgeOverlap="false" class="mr_40" matBadgeColor="warn"></span> -->
            </div>


            <button mat-button disableRipple class="account-btn" (click)="openDetailDialog()">
                <div class="account" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="11px">
                    <img *ngIf="user.headerUrl"
                        src="{{SERVER_URL}}images{{user.headerUrl}}?random={{timeService.timestamp}}">
                    <img *ngIf="!user.headerUrl" src="./assets/images/default-user.svg">
                    <!-- <div fxLayout="row" fxLayoutAlign="center center">
                        <div class="name">{{user.firstName}}</div>
                        <mat-icon style="font-size: 16px; height: 16px; width: 16px">keyboard_arrow_down</mat-icon>
                    </div> -->

                </div>
            </button>
            <!-- <mat-menu #accountDropdown="matMenu" backdropClass="custom__account__menu" xPosition="before">
                <div fxLayout="column" style="">
                    <div class="account-menu-item" routerLink="/profile/edit-user">
                        <mat-icon style="width: 20px; height: 20px; font-size: 20px; margin-right: 5px">
                            person_outline
                        </mat-icon>
                        <div class="text">My Profile</div>
                    </div>
                    <div class="account-menu-item" routerLink="/profile">
                        <mat-icon style="width: 20px; height: 20px; font-size: 20px; margin-right: 5px">
                            business
                        </mat-icon>
                        <div class="text">Company</div>
                    </div> -->
            <!--                    <div class="account-menu-item" routerLink="/profile" *ngIf="user.roles[0].id !== 9">-->
            <!--                        <mat-icon style="width: 20px; height: 20px; font-size: 20px; margin-right: 5px">-->
            <!--                            business-->
            <!--                        </mat-icon>-->
            <!--                        <div class="text">{{'company' | translate}}</div>-->
            <!--                    </div>-->
            <!-- <div style="padding-top: 0.5rem; margin-top: 0.5rem; border-top: 1px solid #e9e9e9">
                        <div class="account-menu-item" (click)="logout()" style="color: #f46a6a">
                            <mat-icon style="width: 20px; height: 20px; font-size: 20px; margin-right: 5px">
                                power_settings_new
                            </mat-icon>
                            <div class="text">Log out</div>
                        </div>
                    </div>

                </div>
            </mat-menu> -->
        </div>

    </mat-toolbar-row>
</mat-toolbar>
